export var LAYER_WIDTH = 30;
export var SCROLLBAR_MIN_WIDTH = 14;
export var SCROLLBAR_WIDTH = 10;
export var CELL_PADDING_HEIGHT = 26;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/constants.js
// module id = 205
// module chunks = 0